import {
  EQUIPMENT_SPECIFIC_CREATE,
  EQUIPMENT_SPECIFIC_DELETE,
  EQUIPMENT_SPECIFIC_EDIT,
  EQUIPMENT_SPECIFIC_EDIT_SINGLE,
  EQUIPMENT_SPECIFIC_FETCH,
  EQUIPMENT_SPECIFIC_UPDATE
} from "../action-types/equipment-specific-types";
import { axiosAction } from "../../utils/axiosAction";

const ENDPOINT = process.env.REACT_APP_ENDPOINT_EQUIPMENT_SPECIFIC_ENDPOINT;

export const getEquipments =
  (equipmentRestaurantId, relationId, brandCode) => async dispatch => {
    const endpoint = `${ENDPOINT}/${equipmentRestaurantId}`;
    return axiosAction.get(endpoint, EQUIPMENT_SPECIFIC_FETCH, dispatch, {
      params: { relation_id: relationId },
    });
  };

export const UpdateEquipmentPieces =
  (piecesToUpdate) => async dispatch => {
    const endpoint = `${ENDPOINT}`;
    return axiosAction.post(
      endpoint,
      EQUIPMENT_SPECIFIC_UPDATE,
      dispatch,
      piecesToUpdate,
    );
  };

export const CreateEquipments =
  (equipmentRestaurantId, brandCode, equipment) => async dispatch => {
    const endpoint = `${ENDPOINT}/${equipmentRestaurantId}`;
    const params = {
      newEquipments: equipment,
    };
    return axiosAction.post(
      endpoint,
      EQUIPMENT_SPECIFIC_CREATE,
      dispatch,
      params,
    );
  };

export const EditEquipments =
  (equipmentRestaurantId, brandCode, equipment) => async dispatch => {
    const endpoint = `${ENDPOINT}/${equipmentRestaurantId}`;
    const params = { editEquipments: equipment };
    return axiosAction.post(
      endpoint,
      EQUIPMENT_SPECIFIC_EDIT,
      dispatch,
      params,
    );
  };

export const EditEquipment = (idPiece, pieceToEdit) => async dispatch => {
  const endpoint = `${ENDPOINT}/${idPiece}`;
  const params = { ...pieceToEdit };
  return axiosAction.put(
    endpoint,
    EQUIPMENT_SPECIFIC_EDIT_SINGLE,
    dispatch,
    params,
  );
};

export const DeleteEquipments =
  (equipmentRestaurantId, brandCode, deletedList) => async dispatch => {
    const params = { deletedEquipments: deletedList };
    return axiosAction.post(
      `${ENDPOINT}/${equipmentRestaurantId}`,
      EQUIPMENT_SPECIFIC_DELETE,
      dispatch,
      params,
    );
  };
